import { connect } from 'react-redux';
import { VALIDATED_CONTROLLED_DOCUMENT } from '../../../../../../redux/actions/app/controlledDocs/controlledDocs.actions';
import { postReassignTaskDocument } from '../../../../../../redux/actions/app/tasks/tasks.actions';
import { getIndexFileUi, getLoadingEntity } from '../../../../../../redux/selectors/ui/ui.selectors';
import FieldsDocument from './FieldsDocument';

const mapStateToProps = (state) => {
    return {
        loading: getLoadingEntity(state, VALIDATED_CONTROLLED_DOCUMENT),
        indexFile: getIndexFileUi(state),
    };
};

const mapDispatchToProps = {
    postReassignTaskDocument,
};

const FieldsDocumentContainer = connect(mapStateToProps, mapDispatchToProps)(FieldsDocument);

export default FieldsDocumentContainer;
